<div class="splash-screen">
    <div class="brand-logo fade-slide-in-up">
        <img src="assets/svg/icons/brand-logo-light.svg" alt="brand logo" />
    </div>
</div>
